import { serviceApi } from '~/api';

const treatmentBrandsUrl = 'brands';

export const get = () => serviceApi.fetchJSON(treatmentBrandsUrl);

export const getById = (treatmentBrandId) =>
  serviceApi.fetchJSON(`${treatmentBrandsUrl}/${treatmentBrandId}`, { method: 'GET' });

export const treatmentBrandsApi = {
  get,
  getById,
};
